/**
 * Terms & conditions page (/obchodni-podminky).
 * Route registration lives in extend.js (Flarum 2 extenders).
 */
export default function registerTerms() {
  // no runtime hooks required
}
flarum.reg.add('dia-theme', 'forum/features/terms', registerTerms);